<script setup lang="ts">
  import { IInputProps } from '@/types'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<IInputProps>()
  const emit = defineEmits(['input', 'change', 'focus', 'blur'])

  const inputValue = ref<string>(props.initialValue || '')

  const handleInput = (event: Event) => {
    const target = event.target as HTMLInputElement
    inputValue.value = target.value
    emit('input', target.value)
  }

  const handleChange = (event: Event) => {
    const target = event.target as HTMLInputElement
    emit('change', target.value)
  }

  const handleFocus = (event: Event) => {
    const target = event.target as HTMLInputElement
    emit('focus', target.value)
  }

  const handleBlur = (event: Event) => {
    const target = event.target as HTMLInputElement
    emit('blur', target.value)
  }

  onMounted(() => {
    if (props.initialValue) {
      inputValue.value = props.initialValue
      emit('input', props.initialValue)
    }
  })

  watch(
    () => props.initialValue,
    newValue => {
      if (newValue !== inputValue.value) {
        inputValue.value = newValue || ''
        emit('input', newValue || '')
      }
    }
  )
</script>

<template>
  <div class="frame-input">
    <i
      class="icon-search"
      :class="loadIcon('search')"
    />
    <input
      :id="props.id"
      v-model="inputValue"
      type="text"
      :placeholder="props.placeholder"
      aria-label="Search input"
      @input="handleInput"
      @change="handleChange"
      @focus="handleFocus"
      @blur="handleBlur"
    />
  </div>
</template>

<style scoped lang="scss">
  .frame-input {
    display: flex;
    align-items: center;
    background-color: #222529;
    border: 2px solid #454545;
    border-radius: 9px;
    width: 100%;
    min-height: 56px;
    padding: 0 12px;
  }

  .icon-search {
    width: 16px;
    height: 16px;
    margin-right: 10px;
  }

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    min-height: 56px;
    color: #ffff;
    font-family: 'Inter';
    font-size: 16px;
    font-weight: 500;

    ::placeholder {
      color: #555555;
      opacity: 0.7;
    }
  }
</style>
